import React from "react";
import { Sparkles, Gem, ShieldCheck, Headphones } from "lucide-react";

const TRUST_ICONS = [Sparkles, Gem, ShieldCheck, Headphones];

export const TrustStripSection = ({ trustStrip }) => (
  <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-y-6 border-t border-border pt-8">
      {trustStrip.map((t, i) => {
        const Icon = TRUST_ICONS[i % TRUST_ICONS.length];
        return (
          <div key={t.label || i} className="flex items-center justify-center gap-2.5 text-center">
            <Icon strokeWidth={1.25} className="h-5 w-5 text-[hsl(var(--primary))] shrink-0" />
            <span className="text-xs sm:text-sm text-foreground/80">{t.label}</span>
          </div>
        );
      })}
    </div>
  </section>
);
